@if (layout.isCompact()) {
  <!-- Bottom tab bar -->
  <nav class="tabs" aria-label="Main">
    @for (link of primary; track link.path) {
      <a
        class="tab"
        [routerLink]="link.path"
        routerLinkActive="is-active"
        [routerLinkActiveOptions]="{ exact: link.exact }"
      >
        <mat-icon>{{ link.icon }}</mat-icon>
        <span>{{ link.label }}</span>
      </a>
    }
    <button type="button" class="tab" [matMenuTriggerFor]="moreMenu" aria-label="More">
      <mat-icon>more_horiz</mat-icon>
      <span>More</span>
    </button>
    <mat-menu #moreMenu="matMenu">
      @for (link of secondary; track link.path) {
        <a mat-menu-item [routerLink]="link.path">
          <mat-icon>{{ link.icon }}</mat-icon>
          <span>{{ link.label }}</span>
        </a>
      }
    </mat-menu>
  </nav>
} @else {
  <!-- Desktop sidebar -->
  <nav class="side" aria-label="Main">
    <a class="side__brand" routerLink="/radios">
      <mat-icon fontSet="material-icons-outlined">graphic_eq</mat-icon>
      <span>HX&nbsp;Player</span>
    </a>

    <ul class="side__list">
      @for (link of primary; track link.path) {
        <li>
          <a
            class="side__link"
            [routerLink]="link.path"
            routerLinkActive="is-active"
            [routerLinkActiveOptions]="{ exact: link.exact }"
          >
            <mat-icon>{{ link.icon }}</mat-icon>
            <span>{{ link.label }}</span>
          </a>
        </li>
      }
    </ul>

    <hr class="side__rule" />

    <ul class="side__list side__list--minor">
      @for (link of secondary; track link.path) {
        <li>
          <a class="side__link" [routerLink]="link.path" routerLinkActive="is-active">
            <mat-icon>{{ link.icon }}</mat-icon>
            <span>{{ link.label }}</span>
          </a>
        </li>
      }
    </ul>

    @defer (on idle) {
      <a
        class="side__store"
        href="https://play.google.com/store/apps/details?id=com.bubs.hx_music_radio_player"
        target="_blank"
        rel="noopener noreferrer"
        (click)="onGooglePlayClick()"
        aria-label="Get HX Player on Google Play"
      >
        <img src="assets/google-play-banner.png" alt="Get it on Google Play" loading="lazy" width="160" height="48" />
      </a>
    } @placeholder {
      <span></span>
    }
  </nav>
}
